var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wl-project-intro-wrapper"},[_c('div',{staticClass:"intro-head-con"},_vm._l((_vm.certifycateList),function(item){return _c('router-link',{key:item.id,attrs:{"to":{name:'introMain',params:{certifyId:item.id}}}},[_vm._v(_vm._s(item.titleName))])}),1),_c('div',{staticClass:"intro-container-con"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }